import ApiClient from 'services/apiClient';

/**
 * Fetch the latest terms and conditions HTML content
 * @returns The HTML content of the latest terms and conditions
 */
export const fetchLatestTermsAndConditions = async (): Promise<any> => {
  const response = await ApiClient.getInstance().get({ url: '/common/getlatesttnc' });
  return response.data;
};

export const fetchPolicyContent = async (slug: string, lang: string): Promise<any> => {
  const response = await ApiClient.getInstance().get({
    url: `/policy/${slug}`,
    params: { lang: lang },
  });
  return response.data;
};
